import React from 'react';
import styled from 'styled-components';
import {
  BaseBox,
  Heading4,
  DoconModal,
  DoconModalContent,
} from '@docon/docon-ui-library';
import { WhatsAppIcon } from 'shared/icons';
import { colors } from 'utilities/colorConfig';

interface IProps {
  visible: boolean;
  requestType: string;
  onCancel: () => void;
}

const Modal = styled<any>(DoconModal)`
  max-width: calc(100vw - 50px);
  border-radius: 10px;

  ${Heading4} { font-weight: bold; margin-bottom: 14px; }

  ${DoconModalContent} {
    padding: 28px 38px 40px;
    font-size: 14px;
    line-height: 20px;
    color: ${colors.primaryColor};
    text-align: center;

    button {
      margin: 0;
      flex: 1;
      font-weight: 600;
    }
  }
`;

const OptInSuccessful = ({
  visible,
  requestType,
  onCancel,
}: IProps) => {

  function renderedContent() {
    let heading = '';
    let text = '';

    switch (requestType) {
      case 'opt-in':
        heading = 'Opt-in successful!';
        text = 'You have successfully subscribed to receive <b>notifications and updates</b> over <b>WhatsApp</b>.';
        break;
      case 'opt-out':
        heading = 'Opt-out successful!';
        text = 'You will no longer receive messages on WhatsApp. You can easily opt-in again in the future via our <b>website</b> or our <b>app</b>.';
        break;
    }

    return { heading, text };
  }

  const { heading, text } = renderedContent();
  return (
    <Modal
      centered
      hideFooter
      isOpen={visible}
      maskClosable={false}
      escapeClosable={false}
      onClose={onCancel}
    >
      <WhatsAppIcon width={40} mb='10px' />
      <Heading4 title={heading} />
      <BaseBox dangerouslySetInnerHTML={{ __html: text }} />

    </Modal>
  );
};

export default OptInSuccessful;